export enum IndikatorTyp {
  TIER = 1,
  LEBENSABSCHNITT = 2,
  DIMENSION_DES_TIERWOHLS = 3,
  INDIKATORENART = 4,
  BEGLEIT_INDIKATOR = 5,
}
